import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=0825c762&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=0825c762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0825c762",
  null
  
)

export default component.exports